import cropImage from './image_crop';

const defaults = {marker: '#23ce6b', line: '#dbdbdb', summary_background: '#ffffff', summary_text: '#363636'};

export default {
  populateCartAppearance(data) {
    const root = this.element.querySelector('#cart-settings');
    if (!root) return;
    const appearance = (data.config || []).find(entry => entry.attr === 'cart.appearance')?.value || {};
    const media = data.cart_media || {};
    if (root.cartState?.objectURL) URL.revokeObjectURL(root.cartState.objectURL);
    root.cartSaved = {url: appearance.header_image || '', cropURL: media.crop_url, filename: media.name || 'cart-header.png'};
    root.cartState = {...root.cartSaved};
    root.querySelector('#cart_header_image').value = '';
    root.querySelector('#cart_remove_image').checked = false;
    root.querySelector('#cart_header_height').value = appearance.header_height || 240;
    Object.entries(defaults).forEach(([field, fallback]) => {
      const value = appearance.colors?.[field] || '';
      root.querySelector(`#cart_color_${field}`).value = value;
      root.querySelector(`input[type=color][data-cart-color="${field}"]`).value = value || fallback;
    });
    if (!root.dataset.cartInstalled) {
      root.dataset.cartInstalled = 'true';
      const input = root.querySelector('#cart_header_image');
      input.addEventListener('change', () => {
        const file = input.files[0];
        if (!file) { this.restoreCartImage(root); return; }
        if (!file.size || file.size > 10 * 1024 * 1024 || !/^image\/(jpeg|png|webp|gif)$/.test(file.type)) {
          input.value = '';
          this.restoreCartImage(root);
          business.showAlert('danger', I18n.t('webshop.cart_settings.save_error'), false, 7000);
          return;
        }
        this.selectCartImage(root, file);
      });
      root.querySelector('#cart_remove_image').addEventListener('change', event => {
        if (event.target.checked) { input.value = ''; this.restoreCartImage(root); }
        this.cartPreviewImage(root);
      });
      root.querySelector('#cart_header_height').addEventListener('input', () => this.cartPreviewImage(root));
      root.querySelector('[data-cart-crop]').addEventListener('click', async event => {
        const state = root.cartState;
        if (!state.url) return;
        event.target.disabled = true;
        try {
          await cropImage(state.objectURL || state.cropURL || state.url, state.filename, file => {
            if (!root.isConnected) return;
            const transfer = new DataTransfer(); transfer.items.add(file); input.files = transfer.files;
            this.selectCartImage(root, file);
          }, key => I18n.t(`webshop.cart_settings.${key}`));
        } catch (_) {
          business.showAlert('danger', I18n.t('webshop.cart_settings.crop_error'), false, 7000);
        } finally { event.target.disabled = false; }
      });
      window.addEventListener('pagehide', () => {
        if (root.cartState?.objectURL) URL.revokeObjectURL(root.cartState.objectURL);
      }, {once: true});
    }
    this.cartPreviewImage(root);
  },

  selectCartImage(root, file) {
    if (root.cartState.objectURL) URL.revokeObjectURL(root.cartState.objectURL);
    const url = URL.createObjectURL(file);
    root.cartState = {url, objectURL: url, filename: file.name};
    root.querySelector('#cart_remove_image').checked = false;
    this.cartPreviewImage(root);
  },

  restoreCartImage(root) {
    if (root.cartState.objectURL) URL.revokeObjectURL(root.cartState.objectURL);
    root.cartState = {...root.cartSaved};
    this.cartPreviewImage(root);
  },

  cartPreviewImage(root) {
    const state = root.cartState;
    const visible = state.url && !root.querySelector('#cart_remove_image').checked;
    root.querySelector('[data-cart-image-preview]').hidden = !visible;
    const image = root.querySelector('[data-cart-image]');
    if (visible) image.src = state.url;
    const height = Number(root.querySelector('#cart_header_height').value);
    image.style.height = `${Math.max(100, Math.min(600, height || 240))}px`;
    root.querySelector('[data-cart-image-name]').textContent = state.filename;
    root.querySelector('[data-cart-crop]').hidden = /\.gif$/i.test(state.filename);
  },

  pickCartColor(event) {
    this.element.querySelector(`#cart_color_${event.target.dataset.cartColor}`).value = event.target.value;
  },

  syncCartColor(event) {
    if (/^#[0-9a-f]{6}$/i.test(event.target.value)) event.target.parentElement.querySelector('input[type=color]').value = event.target.value;
  },

  resetCartColor(event) {
    const button = event.currentTarget;
    this.element.querySelector(`#cart_color_${button.dataset.cartColor}`).value = '';
    button.parentElement.querySelector('input[type=color]').value = button.dataset.cartColorDefault;
  },

  saveCartConfiguration(event) {
    event.preventDefault();
    const form = event.currentTarget;
    if (!form.reportValidity()) return;
    const button = form.querySelector('button[type=submit]'); button.disabled = true;
    const sessionError = () => business.showAlert('danger', I18n.t('webshop.cart_settings.session_error'), false, 9000);
    // A previously opened form can outlive its token after another local sign-in.
    // Refresh through the existing authenticated, tenant-scoped configuration endpoint.
    Rails.ajax({url: `/${this.locale}/webshop/${this.uuid}/config`, type: 'get', dataType: 'json',
      success: config => {
        if(!config?.csrf_token) { sessionError(); button.disabled = false; return; }
        const data = new FormData(form);
        data.set('authenticity_token', config.csrf_token);
        Rails.ajax({url: form.action, type: 'post', data, dataType: 'json',
          success: response => { business.showAlert('success', response.message, false, 5000); this.loadShopConfiguration(this.uuid); },
          error: (response, status, xhr) => {
            if(xhr?.responseText?.includes('InvalidAuthenticityToken')) sessionError();
            else business.showAlert('danger', response?.message || I18n.t('webshop.cart_settings.save_error'), false, 7000);
          },
          complete: () => { button.disabled = false; }
        });
      },
      error: () => { sessionError(); button.disabled = false; }
    });
  }
};
